import { useState } from "react";
import { BarChart3 } from "lucide-react";
import { api, fmtDate, kina } from "@/lib/api";
import { usePoll } from "@/lib/usePoll";

export const PosterStats = () => {
  const [rows, setRows] = useState(null);
  usePoll(() => api.get("/posters/stats").then((r) => setRows(r.data)).catch(() => setRows([])), 30000, []);
  const best = rows?.[0]?.bookings ? rows[0].place : null;
  return (
    <div className="rounded-2xl border border-blue-100 bg-white p-6" data-testid="poster-stats">
      <p className="flex items-center gap-2 font-semibold text-slate-900"><BarChart3 className="h-4 w-4 text-blue-700" /> Poster results</p>
      <p className="mb-4 text-sm text-slate-500">Scans and bookings from each poster location. A booking counts if the passenger books within 7 days of scanning.</p>
      {rows === null ? (
        <p className="text-sm text-slate-400">Loading…</p>
      ) : rows.length === 0 ? (
        <p data-testid="poster-stats-empty" className="rounded-xl bg-[#F4F8FD] px-4 py-6 text-center text-sm text-slate-500">No scans yet. Put up your first poster and results will appear here.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full min-w-[520px] text-sm">
            <thead>
              <tr className="border-b border-slate-100 text-left text-[11px] font-bold uppercase tracking-widest text-slate-500">
                <th className="py-2 pr-3">Location</th><th className="py-2 pr-3 text-right">Scans</th><th className="py-2 pr-3 text-right">Bookings</th><th className="py-2 pr-3 text-right">Completed</th><th className="py-2 pr-3 text-right">Fares</th><th className="py-2 text-right">Last scan</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.place} data-testid={`poster-stats-row-${r.place.replace(/\W+/g, "-").toLowerCase()}`} className="border-b border-slate-50">
                  <td className="py-2.5 pr-3 font-semibold text-slate-900">
                    {r.place}
                    {r.place === best && <span className="ml-2 rounded-full bg-amber-400 px-2 py-0.5 text-[10px] font-bold text-slate-900">Top stand</span>}
                  </td>
                  <td className="py-2.5 pr-3 text-right font-mono-num">{r.scans}</td>
                  <td className="py-2.5 pr-3 text-right font-mono-num">{r.bookings}</td>
                  <td className="py-2.5 pr-3 text-right font-mono-num">{r.completed}</td>
                  <td className="py-2.5 pr-3 text-right font-mono-num">{kina(r.fares)}</td>
                  <td className="py-2.5 text-right text-xs text-slate-500">{fmtDate(r.last_scan)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
